import { render } from "./CreateDetailAgendaView.vue?vue&type=template&id=0a7e200a"
import script from "./CreateDetailAgendaView.vue?vue&type=script&lang=js"
export * from "./CreateDetailAgendaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__